var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"condizioni-generali"},[_c('div',{staticClass:"default-container default-container-smaller"},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.pageApiData.title)}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.pageApiData.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }